import DashboardRouting from './Dashboard.routes';

const DashboardModule = angular.module('DashboardModule', []);

DashboardModule.config(DashboardRouting);

export default DashboardModule; 